// React&NextJS
import { useEffect, useState } from 'react'
// Styles
import s from './FormFooter.module.scss'
import classnames from 'classnames'
// Components
import { Button } from '../../../core/button/Button'
import { Container } from '../../../core/container/Container'

const c = classnames.bind(s)

type Props = {
    saved?: Boolean
    setSaved?: Function
    cancel?: Function
    isLoading?: Boolean
    // formType: obituary form or memory form
    formID: string
}

export const ProfileFormFooter = ({
    cancel,
    // saved,
    // setSaved,
    isLoading,
    formID,
}: Props) => {
    const [isMobile, setIsMobile] = useState(false)
    const [firstRender, setFirstRender] = useState(true)
    const [submitBtnDisabled, setSubmitBtnDisabled] = useState(true)

    useEffect(() => {
        setTimeout(() => {
            setSubmitBtnDisabled(false)
        }, 0)
    }, [])

    useEffect(() => {
        function changeBtnText() {
            if (window.innerWidth < 480 && !isMobile) {
                setIsMobile(true)
            } else if (window.innerWidth >= 480 && isMobile) {
                setIsMobile(false)
            }
        }
        window.addEventListener('resize', changeBtnText)
        if (firstRender) {
            changeBtnText()
            setFirstRender(false)
        }
        return () => window.removeEventListener('resize', changeBtnText)
    }, [isMobile])

    // const openHelperPage = () => {
    //     // TODO: Breyta í prod
    //     if (process.env.NODE_ENV === 'development') {
    //         window.open('http://localhost:3000/common-questions', '_blank')
    //     } else {
    //         window.open('https://minningar.is/common-questions', '_blank')
    //     }
    // }
    const submitButton = () => {
        return (
            <Button type="submit" form={formID} disabled={submitBtnDisabled}>
                {/* {text || 'Senda inn'} */}
                {isMobile ? 'Vista' : 'Vista breytingar'}
            </Button>
        )
    }

    const backButton = () => {
        return (
            <Button type="button" onClick={cancel} variant="ghost">
                {isMobile ? 'Hætta' : 'Hætta við'}
            </Button>
        )
    }

    return (
        <>
            <footer className={c(s.profileFooter, isLoading && s.disabled)}>
                <Container className={s.container} noGrid>
                    <div className={s.buttons__help}>
                        {/* <Button
                            type="button"
                            variant="text"
                            onClick={() => openHelperPage()}
                        >
                            Þarftu aðstoð?
                        </Button> */}
                    </div>
                    <div className={s.buttons__submitDelete}>
                        {backButton()}
                        {submitButton()}
                    </div>
                </Container>
            </footer>
        </>
    )
}
